import { Box, TableCell, TableRow } from "@mui/material";
import moment from "moment";
import React from "react";
import { useNavigate } from "react-router-dom";
import ROUTE_NAMES from "routes/routeNames";
import { formatCurrency } from "utils/commonFunctions";
import { styles } from "../styles";

interface Props {
  user: any;
}

const initials = (name?: string) => {
  const parts = (name || "").trim().split(/\s+/).filter(Boolean);
  const first = parts[0]?.charAt(0) || "";
  const last = parts.length > 1 ? parts[parts.length - 1].charAt(0) : "";
  return `${first}${last}`.toUpperCase() || "U";
};

const UserRow: React.FC<Props> = (props) => {
  const navigate = useNavigate();
  const { user } = props;
  const name =
    user?.fullName || `${user?.firstName || ""} ${user?.lastName || ""}`.trim();

  return (
    <TableRow sx={styles.tableRow}>
      <TableCell>
        <Box
          component="button"
          type="button"
          sx={styles.nameButton}
          onClick={() => {
            navigate(`${ROUTE_NAMES.MAIN_ROUTES.USER_DETAIL}?userId=${user?.id}`);
            window?.location?.reload();
          }}
        >
          <Box sx={styles.rowAvatar} aria-hidden>
            {initials(name)}
          </Box>
          {name || "N/A"}
        </Box>
      </TableCell>
      <TableCell>{user?.email || "N/A"}</TableCell>
      <TableCell>
        {user?.phoneNumber ? `+91 ${user.phoneNumber}` : "N/A"}
      </TableCell>
      <TableCell>{formatCurrency(Number(user?.salary) || 0)}</TableCell>
      <TableCell>
        {user?.dateOfJoining
          ? moment(user.dateOfJoining).format("DD/MM/YYYY")
          : "N/A"}
      </TableCell>
    </TableRow>
  );
};

export default UserRow;
